import { View } from 'react-native'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import {
  isValueOptionColor,
  OptionColor,
  StepOption,
  StepOptions,
  StepVariable,
} from '@order/steps/types'
import OptionDefault, { OptionProps } from './Option/OptionDefault'
import { sDefaultTemplate } from './styles'

import useOrderValues from '@order/hooks/values/useOrderValues'
import useStepsState from '@order/hooks/useStepsState'
import { useAppModeSettings } from 'hooks/useAppModes'
import { Recommendations, RecommendUtils } from 'recommend/RecommendUtils'
import OptionRecommendation from '@order/steps/OptionRecommendation'

interface Props {
  title?: string
  desc?: string
  options: StepOptions
  variable?: StepVariable | null
  OptionComponent?: React.ComponentType<OptionProps>
  recommendations?: Recommendations
}

export default function DefaultTemplate({
  title,
  desc,
  options,
  recommendations,
  OptionComponent = OptionDefault,
  variable,
}: Props) {
  const { states } = useStepsState()
  const { values } = useOrderValues({ states })
  const { preferPackageColor } = useAppModeSettings()

  const getColorOption = (
    colorOption: OptionColor | undefined
  ): OptionColor | undefined => {
    const packageColor = isValueOptionColor(values?.packageColor)
      ? values?.packageColor
      : undefined

    if (colorOption) return colorOption
    if (preferPackageColor && packageColor) return packageColor
    return undefined
  }

  return (
    <Page stage="configuration">
      <Header title={title} desc={desc} />
      <View className={sDefaultTemplate}>
        {options.map((option) => (
          <OptionComponent
            key={option.id}
            options={options.length}
            {...option}
            // Only first recommendation item should have magic glow
            isRecommended={RecommendUtils.options.isRecommended(
              recommendations,
              option
            )}
            colorOption={getColorOption(option.colorOption)}
          />
        ))}
      </View>
      <OptionRecommendation
        recommendations={recommendations}
        options={options}
        variable={variable}
        OptionComponent={OptionComponent}
      />
    </Page>
  )
}
